import Font from './font';
import { ellipseFromEllipticalArc } from './ellipse-from-elliptical-arc';

var getSvgViewport = function (svg) {
  var v = svg.getAttribute('viewBox');
  if (!/\s+/.test(v)) {
    return;
  }
  var match = v.match(/(\d+)\s+(\d+)\s+(\d+)\s+(\d+)/);
  return {
    x1: +match[1],
    y1: +match[2],
    x2: +match[3],
    y2: +match[4],
  };
};

var shouldFill = function (node) {
  var fill = node.getAttribute('fill');
  return fill && fill !== 'none';
};

var shouldStroke = function (node) {
  var stroke = node.getAttribute('stroke');
  var strokeWidth = node.getAttribute('stroke-width');
  return (stroke && stroke !== 'none') || +strokeWidth;
};

function getPathSegmentCoords(str) {
  str = str
    .replace(/[\s\r\t\n]+/gm, ' ')
    .replace(/,/g, ' ')
    .replace(/([^e]{1})\-/g, '$1 -');

  while (/\.\d+\./.test(str)) {
    str = str.replace(/(\.\d+)(\.\d+)/g, '$1 $2');
  }

  return str
    .replace(/(\-|\s+)\./g, '$10.')
    .replace(/^\s+/, '')
    .trim()
    .split(/\s+/)
    .map((item) => +item);
}

var getSupportPointer = function (pointer, control) {
  if (control.x === null || control.y === null) {
    return pointer;
  } else if (pointer.x === control.x) {
    return {
      x: pointer.x,
      y: pointer.y + (pointer.y - control.y),
    };
  } else if (pointer.y === control.y) {
    return {
      y: pointer.y,
      x: pointer.x + (pointer.x - control.x),
    };
  } else {
    var x = pointer.x + (pointer.x - control.x);
    var y = ((x - control.x) * (pointer.y - control.y)) / (pointer.x - control.x) + control.y;

    return {
      x: x,
      y: y,
    };
  }
};

var clearControls = function (control) {
  control.x = control.y = null;
};

var getMoveAction = function (str, pointer, control) {
  var isRelative = str.slice(0, 1) === 'm';
  var value = getPathSegmentCoords(str.slice(1));
  var x = (pointer.x = +value[0] + (isRelative ? pointer.x : 0));
  var y = (pointer.y = +value[1] + (isRelative ? pointer.y : 0));

  clearControls(control);

  return [
    {
      action: 'moveTo',
      args: [x, y],
    },
  ];
};

var getLineAction = function (str, pointer, control) {
  var isRelative = str.slice(0, 1) === 'l';
  var value = getPathSegmentCoords(str.slice(1));
  var length = value.length;
  var result = [];
  var i = 0;

  clearControls(control);

  while (length - 1 - i > 0) {
    (function () {
      var x = (pointer.x = +value[i + 0] + (isRelative ? pointer.x : 0));
      var y = (pointer.y = +value[i + 1] + (isRelative ? pointer.y : 0));
      result.push({
        action: 'lineTo',
        args: [x, y],
      });
    })();
    i += 2;
  }

  return result;
};

var getHorizontalLineAction = function (str, pointer, control) {
  var isRelative = str.slice(0, 1) === 'h';
  var value = getPathSegmentCoords(str.slice(1));
  var length = value.length;
  var result = [];
  var i = 0;

  clearControls(control);

  for (; i < length; i++) {
    (function () {
      var offsetX = isRelative ? pointer.x : 0;
      var x = (pointer.x = +value[i] + offsetX);
      result.push({
        action: 'lineTo',
        args: [x, pointer.y],
      });
    })();
  }

  return result;
};

var getVerticalLineAction = function (str, pointer, control) {
  var isRelative = str.slice(0, 1) === 'v';
  var value = getPathSegmentCoords(str.slice(1));
  var length = value.length;
  var result = [];
  var i = 0;

  clearControls(control);

  for (; i < length; i++) {
    (function () {
      var offsetY = isRelative ? pointer.y : 0;
      var y = (pointer.y = +value[i] + offsetY);
      result.push({
        action: 'lineTo',
        args: [pointer.x, y],
      });
    })();
  }

  return result;
};

var getCurveAction = function (str, pointer, control) {
  var isRelative = str.slice(0, 1) === 'c';
  var value = getPathSegmentCoords(str.slice(1));
  var length = value.length;
  var result = [];
  var i = 0;

  while (length - 1 - i > 0) {
    (function () {
      var offsetX = isRelative ? pointer.x : 0;
      var offsetY = isRelative ? pointer.y : 0;
      var x1 = +value[i + 0] + offsetX;
      var y1 = +value[i + 1] + offsetY;
      var x2 = (control.x = +value[i + 2] + offsetX);
      var y2 = (control.y = +value[i + 3] + offsetY);
      var x = (pointer.x = +value[i + 4] + offsetX);
      var y = (pointer.y = +value[i + 5] + offsetY);
      result.push({
        action: 'bezierCurveTo',
        args: [x1, y1, x2, y2, x, y],
      });
    })();
    i += 6;
  }

  return result;
};

var getSmoothCurveAction = function (str, pointer, control) {
  var isRelative = str.slice(0, 1) === 's';
  var value = getPathSegmentCoords(str.slice(1));
  var length = value.length;
  var result = [];
  var i = 0;

  while (length - 1 - i > 0) {
    (function () {
      var offsetX = isRelative ? pointer.x : 0;
      var offsetY = isRelative ? pointer.y : 0;
      var support = getSupportPointer(pointer, control);
      var x1 = support.x;
      var y1 = support.y;

      var x2 = (control.x = +value[i + 0] + offsetX);
      var y2 = (control.y = +value[i + 1] + offsetY);
      var x = (pointer.x = +value[i + 2] + offsetX);
      var y = (pointer.y = +value[i + 3] + offsetY);
      result.push({
        action: 'bezierCurveTo',
        args: [x1, y1, x2, y2, x, y],
      });
    })();
    i += 4;
  }

  return result;
};

var getQuadraticCurveAction = function (str, pointer, control) {
  var isRelative = str.slice(0, 1) === 'q';
  var value = getPathSegmentCoords(str.slice(1));
  var length = value.length;
  var result = [];
  var i = 0;

  while (length - 1 - i > 0) {
    (function () {
      var offsetX = isRelative ? pointer.x : 0;
      var offsetY = isRelative ? pointer.y : 0;
      var x1 = (control.x = +value[i + 0] + offsetX);
      var y1 = (control.y = +value[i + 1] + offsetY);
      var x = (pointer.x = +value[i + 2] + offsetX);
      var y = (pointer.y = +value[i + 3] + offsetY);
      result.push({
        action: 'quadraticCurveTo',
        args: [x1, y1, x, y],
      });
    })();

    i += 4;
  }

  return result;
};

var getSmoothQuadraticCurveAction = function (str, pointer, control) {
  var isRelative = str.slice(0, 1) === 't';
  var value = getPathSegmentCoords(str.slice(1));
  var length = value.length;
  var result = [];
  var i = 0;

  while (length - 1 - i > 0) {
    (function () {
      var offsetX = isRelative ? pointer.x : 0;
      var offsetY = isRelative ? pointer.y : 0;
      var support = getSupportPointer(pointer, control);
      var x1 = (control.x = support.x);
      var y1 = (control.y = support.y);
      var x = (pointer.x = +value[i + 0] + offsetX);
      var y = (pointer.y = +value[i + 1] + offsetY);
      result.push({
        action: 'quadraticCurveTo',
        args: [x1, y1, x, y],
      });
    })();
    i += 2;
  }

  return result;
};

var getArcToAction = function (str, pointer, control) {
  let isRelative = str.slice(0, 1) == 'a';
  let values = getPathSegmentCoords(str.slice(1));
  let groups = [];

  while (values.length) {
    groups.push(values.splice(0, 7));
  }

  return groups.reduce(function (result, group) {
    let startX = pointer.x;
    let startY = pointer.y;

    let [rx, ry, angle, largeArcFlag, sweepFlag, endX, endY] = group;

    endX = !isRelative ? endX : startX + endX;
    endY = !isRelative ? endY : startY + endY;
    // largeArcFlag = !!largeArcFlag;
    // sweepFlag = !!sweepFlag;

    pointer.x = control.x = endX;
    pointer.y = control.y = endY;

    result.push.apply(
      result,
      ellipseFromEllipticalArc([startX, startY], rx, ry, angle, largeArcFlag, sweepFlag, [
        endX,
        endY,
      ]),
    );

    return result;
  }, []);

  let startX = pointer.x;
  let startY = pointer.y;

  let [rx, ry, angle, largeArcFlag, sweepFlag, endX, endY] = values;

  endX = !isRelative ? endX : startX + endX;
  endY = !isRelative ? endY : startY + endY;
  // largeArcFlag = !!largeArcFlag;
  // sweepFlag = !!sweepFlag;

  pointer.x = control.x = endX;
  pointer.y = control.y = endY;

  return ellipseFromEllipticalArc([startX, startY], rx, ry, angle, largeArcFlag, sweepFlag, [
    endX,
    endY,
  ]);
};

var createPath = function (node, instructions, shouldFill, shouldStroke) {
  var outline = node.getAttribute('d');
  createPathFromOutline.call(this, outline, instructions, shouldFill, shouldStroke);
};

var createPathFromOutline = function (outline, instructions, shouldFill, shouldStroke) {
  if (!outline) throw 'SVGram: missing outline';

  var chunks = outline
    .replace(/([a-z])/gi, '@_@$1')
    .split('@_@')
    .slice(1);
  var pointer = { x: 0, y: 0 };
  var control = { x: null, y: null };

  chunks.forEach(function (chunk, i) {
    var code = chunk.slice(0, 1).toLowerCase();

    if (code === 'z') {
      return instructions.push({
        action: 'closePath',
      });
    }

    var handler = {
      m: getMoveAction,
      l: getLineAction,
      h: getHorizontalLineAction,
      v: getVerticalLineAction,
      a: getArcToAction,
      c: getCurveAction,
      s: getSmoothCurveAction,
      q: getQuadraticCurveAction,
      t: getSmoothQuadraticCurveAction,
    }[code];

    if (!handler) {
      return;
    }

    var action = handler(chunk, pointer, control);

    if (!action.forEach) {
      instructions.push(action);
    } else {
      instructions.push.apply(instructions, action);
    }
  });
};

export default function (svg) {
  var startTime = new Date();

  // Разбираем SVG

  var xml = (function () {
    if (window.DOMParser) {
      return new window.DOMParser().parseFromString(svg, 'text/xml');
    } else {
      var xml = new ActiveXObject('Microsoft.XMLDOM');
      xml.async = false;
      return xml.loadXML(svg);
    }
  })();

  // Генерируем набор инструкций

  var instructions = [];
  var currentStyles = this.currentStyles;

  var shouldFill = function (node) {
    var attrStyles = this.getNodeStyles(node);
    var parentFill = this.currentStyles.fillColor;
    var nodeFill = attrStyles.fillColor;
    if (nodeFill) {
      return nodeFill !== 'none';
    } else if (parentFill) {
      return parentFill !== 'none';
    } else {
      return false;
    }
  };

  var shouldStroke = function (node) {
    var attrStyles = this.getNodeStyles(node);
    var parentStrokeColor = this.currentStyles.strokeColor;
    var parentStrokeWidth = this.currentStyles.strokeWidth;
    var nodeStrokeColor = attrStyles.strokeColor;
    var nodeStrokeWidth = attrStyles.strokeWidth;
    if (nodeStrokeWidth) {
      return nodeStrokeWidth !== 'none';
    } else if (nodeStrokeColor) {
      return true;
    } else if (parentStrokeColor) {
      return parentStrokeWidth !== 'none';
    } else if (parentStrokeColor) {
      return true;
    } else {
      return false;
    }
  };

  var addSimpleAction = function (name) {
    instructions.push({
      action: name,
    });
  };

  var begin = function () {
    addSimpleAction('beginPath');
  };

  var close = function () {
    addSimpleAction('closePath');
  };

  var save = function () {
    addSimpleAction('save');
  };

  var restore = function () {
    addSimpleAction('restore');
  };

  var stroke = function () {
    // Описываем свойство по-умолчанию
    // if (!currentStyles.strokeWidth) {
    //     instructions.push({
    //         action: 'setProperty',
    //         name:  'strokeWidth',
    //         value: 1
    //     });
    // }
    // Чертим
    addSimpleAction('stroke');
  };

  var fill = function () {
    addSimpleAction('fill');
  };

  /**
   * Applying styles
   * @param  {Array}   list
   * @param  {boolean} state
   */
  var toggleStylesDiff = (list, state) => {
    var valuePropName = state ? 'next' : 'prev';

    list.forEach((item) => {
      var propertyName = item.name;
      var propertyValue = item[valuePropName];

      /font/i.test(propertyName) &&
        (() => {
          var currentStyles = this.currentStyles;

          var checkAndSet = function (name) {
            return item.name === name ? propertyValue : currentStyles[name];
          };

          var fontSize = checkAndSet('fontSize');
          var fontWeight = checkAndSet('fontWeight');
          var fontFamily = checkAndSet('fontFamily');

          propertyName = 'font';
          propertyValue = new Font(fontSize, fontWeight, fontFamily);
        })();

      // Applying new styles only if state == true

      state &&
        instructions.push({
          action: 'setProperty',
          name: propertyName,
          value: propertyValue,
        });

      // Saving current state

      this.currentStyles[item.name] = item[valuePropName];
    });
  };

  /**
   * Applying transforms
   * @param  {Array}   list
   * @param  {boolean} state
   */
  var toggleTransforms = (list, state) => {
    var mod = state ? 1 : -1;

    !state && list && list.reverse && list.reverse();

    list &&
      list.length &&
      list.forEach(function (item) {
        instructions.push({
          action: item.name,
          state: state,
          args: item.args.map(function (v) {
            return v * mod;
          }),
        });
      });
  };

  var nodeHandlers = {
    svg: function (node) {
      var getValue = function (v) {
        return !/[^0-9]/.test(v) ? +v : /px/i.test(v) ? parseInt(v) : null;
      };
      this.viewport = getSvgViewport(node);
      this.width = getValue(node.getAttribute('width'));
      this.height = getValue(node.getAttribute('height'));
    },
    g: function (node) {
      //
    },
    rect: function (node, shouldFill, shouldStroke) {
      var x = +node.getAttribute('x');
      var y = +node.getAttribute('y');
      var width = +node.getAttribute('width');
      var height = +node.getAttribute('height');
      var r = +node.getAttribute('rx') || +node.getAttribute('ry') || 0;

      if (!r) {
        var addInstruction = function (name) {
          instructions.push({
            action: name,
            args: [x, y, width, height],
          });
        };
        shouldStroke && addInstruction('strokeRect');
        shouldFill && addInstruction('fillRect');
      } else {
        if (r > width / 2) r = width / 2;
        if (r > height / 2) r = height / 2;

        var outline = [];

        outline.push('M' + (x + r) + ' ' + y);
        outline.push('L' + (x + width - r) + ' ' + y);
        outline.push('Q' + (x + width) + ' ' + y + ' ' + (x + width) + ' ' + (y + r));
        outline.push('L' + (x + width) + ' ' + (y + height - r));
        outline.push(
          'Q' + (x + width) + ' ' + (y + height) + ' ' + (x + width - r) + ' ' + (y + height),
        );
        outline.push('L' + (x + r) + ' ' + (y + height));
        outline.push('Q' + x + ' ' + (y + height) + ' ' + x + ' ' + (y + height - r));
        outline.push('L' + x + ' ' + (y + r));
        outline.push('Q' + x + ' ' + y + ' ' + (x + r) + ' ' + y);
        outline.push('Z');

        begin();
        createPathFromOutline.call(this, outline.join(''), instructions, shouldFill, shouldStroke);

        shouldFill && fill();
        shouldStroke && stroke();
      }
    },
    path: function (node, shouldFill, shouldStroke) {
      begin();
      createPath.call(this, node, instructions, shouldFill, shouldStroke);
      shouldFill && fill();
      shouldStroke && stroke();
    },
    polyline: function (node, shouldFill, shouldStroke) {
      begin();

      Array.from(node.points).forEach(function (point, i) {
        instructions.push({
          action: i === 0 ? 'moveTo' : 'lineTo',
          args: [point.x, point.y],
        });
      });

      shouldFill && fill();
      shouldStroke && stroke();
    },
    line: function (node, shouldFill, shouldStroke) {
      var x1 = +node.getAttribute('x1');
      var y1 = +node.getAttribute('y1');
      var x2 = +node.getAttribute('x2');
      var y2 = +node.getAttribute('y2');

      begin();

      instructions.push(
        {
          action: 'moveTo',
          args: [x1, y1],
        },
        {
          action: 'lineTo',
          args: [x2, y2],
        },
      );

      close();

      shouldFill && fill();
      shouldStroke && stroke();
    },
    circle: function (node, shouldFill, shouldStroke) {
      begin();
      var x = +node.getAttribute('cx');
      var y = +node.getAttribute('cy');
      var r = +node.getAttribute('r');

      instructions.push({
        action: 'moveTo',
        args: [x + r, y],
      });

      instructions.push({
        action: 'drawCircle',
        x: x,
        y: y,
        r: r,
      });

      shouldFill && fill();
      shouldStroke && stroke();
    },
    ellipse: function (node, shouldFill, shouldStroke) {
      var x = +node.getAttribute('cx');
      var y = +node.getAttribute('cy');
      var rx = +node.getAttribute('rx');
      var ry = +node.getAttribute('ry');

      begin();

      instructions.push({
        action: 'drawEllipse',
        x: x,
        y: y,
        rx: rx,
        ry: ry,
      });

      close();

      shouldFill && fill();
      shouldStroke && stroke();
    },
    text: function (node, shouldFill, shouldStroke) {
      var self = this;
      var x = +node.getAttribute('x');
      var y = +node.getAttribute('y');

      var positionTextPointer = function (type, x, y) {
        instructions.push({
          action: type + 'TextPointer',
          x: x || 0,
          y: y || 0,
        });
      };

      var insertText = function (str) {
        instructions.push({
          action: 'insertText',
          value: str,
          fill: shouldFill,
          stroke: shouldStroke,
        });
      };

      var nodeHandler = (node, shouldFillBool, shouldStrokeBool) => {
        if (node.nodeType === 3) {
          return insertText(node.textContent);
        } else if (node.nodeName !== 'tspan') {
          return;
        }

        // Moving text pointer

        var x = +node.getAttribute('x');
        var y = +node.getAttribute('y');

        if (x || y) {
          positionTextPointer('move', x, y);
        }

        var dx = +node.getAttribute('dx');
        var dy = +node.getAttribute('dy');

        if (dx || dy) {
          positionTextPointer('shift', dx, dy);
        }

        // Applying styles

        var nodeStyles = this.getNodeStyles(node);
        var nodeStylesDiff = this.getNodeStylesDiff(nodeStyles);
        var nodeTransforms = this.getNodeTransforms(node);
        var shouldApplyStyles = nodeStylesDiff && nodeStylesDiff.length;
        var shouldApplyTransforms = nodeTransforms && nodeTransforms.length;

        var shouldThisNodeFill =
          nodeStyles.fillColor !== 'none' && (nodeStyles.fillColor || shouldFillBool);
        var shouldThisNodeStroke =
          nodeStyles.strokeColor !== 'none' &&
          (nodeStyles.strokeColor || nodeStyles.strokeWidth || shouldStrokeBool);

        if (shouldApplyStyles || shouldApplyTransforms) {
          save();
        }

        shouldApplyStyles && toggleStylesDiff.call(this, nodeStylesDiff, true);
        shouldApplyTransforms && toggleTransforms.call(this, nodeTransforms, true);

        // working with child nodes

        if (node.childNodes) {
          [].forEach.call(node.childNodes, function (node) {
            nodeHandler.call(this, node, shouldThisNodeFill, shouldThisNodeStroke);
          });
        }

        if (shouldApplyStyles || shouldApplyTransforms) {
          restore();
        }

        shouldApplyStyles && toggleStylesDiff.call(this, nodeStylesDiff, false);
      };

      begin();

      // Moving text pointer

      if (x && y) {
        positionTextPointer('move', x, y);
      }

      // Working with child nodes

      [].forEach.call(node.childNodes, nodeHandler);

      // Resetting text pointer

      positionTextPointer('move', 0, 0);

      close();
    },
    tspan: function (node, shouldFill, shouldStroke) {
      // Do nothing
    },
    title: function (node, shouldFill, shouldStroke) {
      // Do nothing
    },
    defs: function (node) {
      node.childNodes &&
        [].forEach.call(node.childNodes, function (child) {
          var id = child.getAttribute('id');
          if (id) {
            defs[id] = child;
          }
        });
    },
    use: function (node, shouldFill, shouldStroke) {
      var id = (node.getAttribute('xlink:href') + '').replace('#', '');
      if (id && defs[id] && defs[id].tagName) {
        var nodeHandler = nodeHandlers[defs[id].tagName.toLowerCase()];
        if (nodeHandler) {
          nodeHandler.call(this, defs[id], shouldFill, shouldStroke);
        }
      }
    },
  };

  var inspectNode = (node, shouldFillBool, shouldStrokeBool, depth) => {
    if (!node.tagName) {
      return;
    }

    var depth = depth || 1;
    var i = depth;

    var nodeStyles = this.getNodeStyles(node);
    var nodeStylesDiff = this.getNodeStylesDiff(nodeStyles);
    var nodeTransforms = this.getNodeTransforms(node);
    var shouldApplyStyles = nodeStylesDiff && nodeStylesDiff.length;
    var shouldApplyTransforms = nodeTransforms && nodeTransforms.length;

    var shouldThisNodeFill =
      nodeStyles.fillColor !== 'none' && (nodeStyles.fillColor || shouldFillBool);
    var shouldThisNodeStroke =
      nodeStyles.strokeColor !== 'none' &&
      (nodeStyles.strokeColor || nodeStyles.strokeWidth || shouldStrokeBool);

    if (shouldApplyStyles || shouldApplyTransforms) {
      save();
    }

    shouldApplyStyles && toggleStylesDiff(nodeStylesDiff, true);
    shouldApplyTransforms && toggleTransforms(nodeTransforms, true);

    if (node.tagName) {
      var nodeHandler = nodeHandlers[node.tagName.toLowerCase()];
      if (nodeHandler) {
        nodeHandler.call(this, node, shouldThisNodeFill, shouldThisNodeStroke);
      }
    }

    if (node && node.childNodes) {
      [].forEach.call(node.childNodes, (child) => {
        inspectNode(child, shouldThisNodeFill, shouldThisNodeStroke, depth + 1);
      });
    }

    if (shouldApplyStyles || shouldApplyTransforms) {
      restore();
    }

    shouldApplyStyles && toggleStylesDiff(nodeStylesDiff, false);
  };

  var defs = (this.defs = {});

  inspectNode((xml.children || xml.childNodes || [])[0]);

  this.instructions = instructions;
}
